import React from 'react';
import { NumericFormat } from 'react-number-format';

export const PriceFormat: React.FC<{
  value: number | string | undefined;
  prefix?: string;
  suffix?: string;
  thousandSeparator?: string;
}> = (props) => {
  return (
    <NumericFormat
      displayType={'text'}
      thousandSeparator={' '}
      decimalScale={2}
      {...props}
    />
  );
};
